import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  admin: null,
  token: null,
  login: () => {},
  logout: () => {},
  update: () => {},
});
